import axios from '../http'
import {API} from "../const"

const api = API+'/notice';

export function getNoticeState() {
    return axios.get(api);
}

export  function popNotice(){
    return axios.get(api+"/pop");
}

export function get(id){
    return axios.get(api+"/"+id);
}

export function findAll(params){
    return axios.get(api+"/page", {params})
}